import request from 'config/axios'

const getReportURL = ({ accountType, startDate, endDate }) =>
  `gringott/statements/${accountType}?startDate=${startDate}&endDate=${endDate}`

const getDownloadURL = ({ accountType, startDate, endDate, format }) =>
  `gringott/report/${accountType}?startDate=${startDate}&endDate=${endDate}&format=${format}`

const configs = {
  responseType: 'arraybuffer'
}

export const getAccountStatementReport = ({ payload }) => request.get(getReportURL(payload))
export const getAccountStatementDownload = ({ payload }) => (
  request.get(getDownloadURL(payload), configs)
)
